<template>
  <div class="jensen-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex> \$2\$ </div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
             <label>函数中心点 f(E[x])</label>
             <span class="val">{{ fCent.toFixed(2) }}</span>
          </div>
          <div class="hud-item orange">
             <label>期望中心点 E[f(x)]</label>
             <span class="val">{{ eCent.toFixed(2) }}</span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 450 240" preserveAspectRatio="xMidYMid meet">
          <g transform="translate(50, 200)">
             <!-- 凸函数曲线 (凸向下 f(x)=x^2) -->
             <path :d="curvePath" fill="none" stroke="#64748b" stroke-width="3" />
             
             <!-- 割线 (Secant Line) -->
             <line :x1="a*3" :y1="-f(a)*0.6" :x2="b*3" :y2="-f(b)*0.6" stroke="#fbbf24" stroke-width="2" />
             
             <!-- a, b 点 -->
             <circle :cx="a*3" :cy="-f(a)*0.6" r="4" fill="#f43f5e" />
             <text :x="a*3" y="15" text-anchor="middle" fill="#f43f5e" font-size="10">a</text>
             <circle :cx="b*3" :cy="-f(b)*0.6" r="4" fill="#0ea5e9" />
             <text :x="b*3" y="15" text-anchor="middle" fill="#0ea5e9" font-size="10">b</text>

             <!-- 中点对比线 -->
             <line :x1="(a+b)*1.5" :y1="-f((a+b)/2)*0.6" :x2="(a+b)*1.5" :y2="-(f(a)+f(b))*0.3" stroke="#fbbf24" stroke-dasharray="2,2" />
             <circle :cx="(a+b)*1.5" :cy="-f((a+b)/2)*0.6" r="5" fill="#10b981" /> <!-- 曲线中点 -->
             <circle :cx="(a+b)*1.5" :cy="-(f(a)+f(b))*0.3" r="5" fill="#f43f5e" /> <!-- 割线中点 -->
             
             <text x="350" y="-180" fill="#10b981" font-size="9" font-weight="900">曲线中点 (低)</text>
             <text x="350" y="-140" fill="#f43f5e" font-size="9" font-weight="900">割线中点 (高)</text>
          </g>
        </svg>
        <div class="physics-caption">结论：凹函数（凸向下）的割线中心点，永远在曲线中心点的上方。</div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="flex-row gap-6">
              <div class="flex-1">
                 <label class="s-label">参数 x₁ (位置A)</label>
                 <el-slider v-model="a" :min="10" :max="50" size="small"></el-slider>
              </div>
              <div class="flex-1">
                 <label class="s-label">参数 x₂ (位置B)</label>
                 <el-slider v-model="b" :min="60" :max="110" size="small"></el-slider>
              </div>
           </div>
        </div>
        <div class="discovery-card-discovery-special" v-latex>
           <i class="el-icon-refresh-left"></i>
           <p><strong>实战物理/经济学：</strong>琴生不等式是风险厌恶的数学基础。<strong>观察：</strong>调节 $x_1, x_2$，你会发现**割线中点（红色）永远在曲线点（绿色）上方**。只要函数是开口向上的，这个规律就是绝对真理。这解释了为何风险分散能产生比期望更多的价值。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'JensenInequalityViz',
  data() { return { a: 20, b: 80 } },
  computed: {
    curvePath() {
       let p = "M 0,0 ";
       for(let x=0; x<=350; x+=10) {
          const v = Math.pow(x/25, 2);
          p += `L ${x},${-v} `;
       }
       return p;
    },
    fCent() { return this.f((this.a + this.b) / 2); },
    eCent() { return (this.f(this.a) + this.f(this.b)) / 2; }
  },
  methods: {
    f(x) { return Math.pow(x/8, 2) * 5; } // Fake parabola for visual
  }
}
</script>

<style scoped lang="scss">
@import "./InequalityStyle.scss";
.jensen-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
